import { atom } from 'jotai';

export const isHandlingGoogleAuthAtom = atom<boolean>(false);
